require('./CardOperatingLimit.scss');

// @core
const React = require('react');
const PropTypes = require('prop-types');
// @utilities
const { getFormattedString} = require('utilities/currencyHelper');
const { FormattedText } = require('core/i18n').i18n;
const { cardValidationRules } = require('utilities/accessHelperConditions/cards');
// @commons
const { OKLink } = require('commonsComponents/OKLink');
// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
//@constants
const { EV_STATUS } = require ('constants/contactCenter/cardStatus');

class CardOperatingLimit extends React.Component {

    canChangeLimits(immCard) {
        const statusCode = immCard.get('status');
        const isActive = immCard.get('active');

        return isActive && (EV_STATUS === statusCode)
    }

    getModifyLimitLink(type) {
        const { immCard } = this.props;
        const cardId = immCard.get('cardId');
        const link = `/myprofile/cards/${cardId}/${type}/modify-debit-limit`;

        if (this.canChangeLimits(immCard)) {
            return (
                <OKLink isOKLinkOld={true} to={link}>
                    <FormattedText value="cardDetails-modifyLimitLabel"/>
                </OKLink>
            );
        }

        return null;
    }

    render() {
        const { immCard } = this.props;
        const cardId = immCard.get('cardId');

        const limitCommerce = getFormattedString({
            amount: immCard.getIn(['limitCommerce', 'amount']),
            currency: immCard.getIn(['limitCommerce', 'currency']),
            decimalsLength: 0
        });

        const limitExtract = getFormattedString({
            amount: immCard.getIn(['limitExtract', 'amount']),
            currency: immCard.getIn(['limitExtract', 'currency']),
            decimalsLength: 0
        });

        let limitCommerceLink;
        let limitExtractLink;
        if (cardValidationRules.CARD_MODIFY_DEBIT_LIMITS.validator({immCard})) {
            limitCommerceLink = (
                <OKLink
                    modifier="emphasize"
                    to={`/myprofile/cards/${cardId}/modify-debit-limits/commerce`}
                    id={'btnCardDebitLimitsCommerceLink'}
                >
                    <FormattedText value="cardDetails-limitCommerceLink" />
                </OKLink>
            );
            limitExtractLink = (
                <OKLink
                    modifier="emphasize"
                    to={`/myprofile/cards/${cardId}/modify-debit-limits/extract`}
                    id={'btnCardDebitLimitsExtractLink'}
                >
                    <FormattedText value="cardDetails-limitExtractLink" />
                </OKLink>
            );
        }

        return (
            <OKInformativeList title="cardDetails-operatingLimitTitle" columns={2}>
                <OKInformativeListItem
                    title="cardDetails-limitCommerce"
                    bodyText={limitCommerce}
                >
                    <WebappRender>
                        {limitCommerceLink}
                    </WebappRender>
                    <ContactCenterRender>
                        {this.getModifyLimitLink('commerce')}
                    </ContactCenterRender>
                </OKInformativeListItem>
                <OKInformativeListItem
                    title="cardDetails-limitExtract"
                    bodyText={limitExtract}
                >
                    <WebappRender>
                        {limitExtractLink}
                    </WebappRender>
                    <ContactCenterRender>
                        {this.getModifyLimitLink('atm')}
                    </ContactCenterRender>
                </OKInformativeListItem>
            </OKInformativeList>
        );
    }
}

CardOperatingLimit.propTypes = {
    immCard: PropTypes.object.isRequired
};

module.exports = CardOperatingLimit;
